import { Injectable } from '@angular/core';
// import { GridDataService } from './base-data-services/grid-data.service';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { API_URL } from 'common/constants/sm-constants';
import { SystemService } from 'common/services/core-services/system.service';
import { GridParams, GridPostParams } from 'common/models/utility-models/list-utility.model';
import { environment } from 'src/environments/environment';
import { FeedbackModel } from 'common/models/page-models/feedback/feedback-data-model';
import { FeedbackListingModel, FeedbackGridPostParams } from 'common/models/page-models/feedback/feedback-grid-model';
import { GridDataService } from '../../base-data-services/grid-data.service';


@Injectable({
    providedIn: 'root'
})
export class FeedbackGridDataService extends GridDataService<FeedbackListingModel, FeedbackModel> {
    constructor(http: SmApiService, protected override  ss: SystemService) {
        super(API_URL.feedbackGrid, http, ss);
        
    }

    createInstance(): FeedbackListingModel {
        return new FeedbackListingModel();
    }

     getGridParams(param): GridPostParams {
        return new FeedbackGridPostParams();
    }

     getDeleteUrl(): string {
        return environment.apiUrl+API_URL.deleteFeedback;
    }

     override getDeletePayload(data){
        let payload;
        if(data.id){
            payload={id:data.id}
        }
        else{
            payload=data;
        }
        
        return payload;
    }

     override transformDataModel(apiRes: any, param: string) {
        super.transformDataModel(apiRes, param);
        apiRes[param].forEach((key) => {
            key.preview = 'view';
        });
        return apiRes;
    }

}
